"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TestEditableCell = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _tableContext = require("../../Context/tableContext");
var _classnames = _interopRequireDefault(require("classnames"));
var _Helpers = require("../../Helpers");
var _ykbUtils = require("ykb-utils");
var _RenderInput = _interopRequireWildcard(require("./RenderInput"));
var _RowSelection = _interopRequireDefault(require("./RowSelection"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TestEditableCell = exports.TestEditableCell = function TestEditableCell(props) {
  var columnDef = props.columnDef,
    row = props.row,
    rowKey = props.rowKey,
    depth = props.depth,
    prefixCls = props.prefixCls,
    id = props.id,
    hasChildren = props.hasChildren,
    cellIndex = props.cellIndex,
    isActiveFilter = props.isActiveFilter,
    isExpanded = props.isExpanded,
    isFiltered = props.isFiltered,
    rowId = props.rowId,
    rowIndex = props.rowIndex,
    setIsExpanded = props.setIsExpanded,
    expandable = props.expandable,
    showChildForFilter = props.showChildForFilter;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var _useState3 = (0, _react.useState)(_tableContext.eventHub.getState('rowSelection')),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    rowSelection = _useState4[0],
    setRowSelection = _useState4[1];
  var _useState5 = (0, _react.useState)(row[columnDef.dataIndex]),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    innerValue = _useState6[0],
    setInnerValue = _useState6[1];
  var _useState7 = (0, _react.useState)(_tableContext.eventHub.getState('locale')),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    locale = _useState8[0],
    setLocale = _useState8[1];
  var _useState9 = (0, _react.useState)(_tableContext.eventHub.getState('focusedHighlight')),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    focusedHighlight = _useState10[0],
    setFocusedHighlight = _useState10[1];
  var selectedCellRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var cellEditingId = rowKey + '_' + columnDef.dataIndex;
    var unsubscriber = [_tableContext.eventHub.on('update.focusedHighlight', setFocusedHighlight), _tableContext.eventHub.on("isEditing.".concat(cellEditingId), setIsEditing), _tableContext.eventHub.on('update.locale', setLocale), _tableContext.eventHub.on('update.rowSelection', setRowSelection), _tableContext.eventHub.on("update.row.".concat(rowKey), function (_row) {
      setInnerValue(_row[columnDef.dataIndex]);
    })];
    return function () {
      unsubscriber.forEach(function (fn) {
        return fn();
      });
    };
  }, []);
  (0, _react.useEffect)(function () {
    setInnerValue(row[columnDef.dataIndex]);
  }, [row]);
  var isCellEditingCheck = (0, _react.useMemo)(function () {
    return focusedHighlight && isEditing;
  }, [focusedHighlight, isEditing]);
  var isExpandedColumn = (0, _react.useMemo)(function () {
    return !(expandable !== null && expandable !== void 0 && expandable.expandedRowRender) && !(expandable !== null && expandable !== void 0 && expandable.expandIconColumnIndex) || columnDef.dataIndex === 'expandedColumn';
  }, [(expandable === null || expandable === void 0 ? void 0 : expandable.expandedRowRender) && !(expandable !== null && expandable !== void 0 && expandable.expandIconColumnIndex), columnDef.dataIndex]);
  var isFixedColumn = (0, _react.useMemo)(function () {
    var _columnDef$fixed;
    return (_columnDef$fixed = columnDef.fixed) !== null && _columnDef$fixed !== void 0 ? _columnDef$fixed : false;
  }, [columnDef.fixed]);
  var marginLeft = 20 * depth;
  var fixedKey = (columnDef === null || columnDef === void 0 ? void 0 : columnDef.fixed) || 'left';
  var className = (0, _react.useMemo)(function () {
    return "".concat(prefixCls, "-cell row-").concat(row.index, "-cell-").concat(cellIndex, " ").concat(isFixedColumn ? 'sticky-cell' : '', " ").concat(fixedKey);
  }, [isFixedColumn]);
  var expandIconColumnIndex = (0, _react.useMemo)(function () {
    return expandable !== null && expandable !== void 0 && expandable.expandIconColumnIndex || !!rowSelection ? 1 : 0;
  }, [expandable === null || expandable === void 0 ? void 0 : expandable.expandIconColumnIndex]);
  var cellStyleCls = typeof columnDef.cellStyle == 'function' ? columnDef.cellStyle(_objectSpread(_objectSpread({}, row), {}, (0, _defineProperty2.default)({}, columnDef.dataIndex, innerValue)), row.index) : columnDef.cellStyle || '';
  var isDisabled = checkDisable(columnDef, row);
  if (!hasChildren || cellIndex !== expandIconColumnIndex) {
    marginLeft += 10;
  }

  // checkColumnType altında render methodu hazırlanır.
  // eğer kolona ait bir render varsa kolon altına eklenir.
  // kolona ait bir render yoksa colon altına render methodu actionHandler yardımı ile eklenir.
  // let render = () => {};
  // useEffect(() => {
  //   render = Utils.getDefaultColumnRender(locale, columnDef);
  // }, [locale, columnDef]);

  var render = (0, _react.useMemo)(function () {
    return _Helpers.Utils.getDefaultColumnRender(locale, columnDef);
  }, [locale, columnDef]);

  // Kolona ait value değerini almak için,
  // accessorFn columns altında ki methodune gider
  // burada tanımlı olan rowKey degerine göre value getirir.
  // const value2 = getValue();
  var value = innerValue;
  var childOrValue = value !== null && value !== void 0 ? value : '';
  if (typeof render == 'function') {
    childOrValue = render(value, row) || '';
  }
  var EditableColumnCell = _react.Fragment;
  // row selection veya expanded column olması durumunda cell altına boss button basmaması adına bu kontrol eklendi
  var ignoreCell = ['expandedColumn', 'rowSelection'];
  if (ignoreCell.includes(columnDef.dataIndex) || !columnDef.editable) {
    EditableColumnCell = function EditableColumnCell() {
      return childOrValue;
    };
  }
  var indexClass = row.key.replace(/[.]/g, '-');
  var handleClickEditableCellButton = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(e) {
      var validationHasError;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            validationHasError = _tableContext.eventHub.getState('validationHasError');
            try {
              if (columnDef.editable && !validationHasError.current && !isDisabled) {
                _tableContext.eventHub.emit('setEditingKey&selectedDataIndex', rowKey, columnDef.dataIndex);
                // input onblur'unda eğer bir önceki editable cell hata alırsa yeni tıklanan hücre
                // edit moda geçmemeli. Mevcut input'un focus'u devam etmeli.
              }
            } catch (err) {
              console.info('DefaultEditableCell handleClickEditableCellButton does not updates dataIndex and key unless validation completed', err);
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [columnDef.editable, isDisabled]);
  var editOnFocus = (0, _react.useCallback)(function () {
    var validationHasError = _tableContext.eventHub.getState('validationHasError');
    if (columnDef.editable && !validationHasError.current && !isDisabled) {
      // Tab yapıldıgında sonradan data setlemesi gormesin diye data setleme işleminden sonrasında düşmesi için (tablo refresinden sonra)
      // settimeout ile button focus işlemi, data setlemesinin arkasına almak için eklendi.

      if (!!_tableContext.eventHub.getState('editOnFocus') && !validationHasError.current) {
        _tableContext.eventHub.emit('setEditingKey&selectedDataIndex', rowKey, columnDef.dataIndex);
      }

      // hata olup olmaksizin tab ile focus atması için if dışında bırakıldı.
      _tableContext.eventHub.emit('update.submitingElementClassName', "editable-cell-".concat(indexClass, "-").concat(columnDef.dataIndex));
    }
  }, [columnDef.editable, isDisabled]);

  // #region styles
  var preparedClassName = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, className, true), cellStyleCls, true), 'row-selection', (columnDef === null || columnDef === void 0 ? void 0 : columnDef.dataIndex) === 'rowSelection'), "customError", cellStyleCls && cellStyleCls.indexOf('custom-error') > -1 || cellStyleCls.indexOf('customError') > -1), 'position-sticky', isFixedColumn), 'position-relative', !isFixedColumn), "disabled", isDisabled), "focused", isCellEditingCheck), "table-column-".concat(columnDef.dataIndex), true), 'editable-table-cell', columnDef.editable));
  var offsetWidth = null; // TODO

  var wrapperStyle = {
    display: cellIndex === expandIconColumnIndex ? 'flex' : null,
    width: cellIndex === expandIconColumnIndex ? columnDef.size - marginLeft : null,
    marginLeft: cellIndex === expandIconColumnIndex ? marginLeft : null,
    // display: "flex",
    alignItems: 'center',
    justifyContent: 'flex-start'
  };
  var useCustomBorder = true; // tableSize === "xsmall";

  var editableButtonClassname = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    'editable-cell-button ': columnDef.editable
  }, "editable-cell-".concat(indexClass, "-").concat(columnDef === null || columnDef === void 0 ? void 0 : columnDef.dataIndex), true), "disabled", isDisabled), "display", (columnDef === null || columnDef === void 0 ? void 0 : columnDef.dataIndex) === 'rowSelection' ? 'none' : 'block'), columnDef === null || columnDef === void 0 ? void 0 : columnDef.type, true));

  // #endregion

  return /*#__PURE__*/_react.default.createElement("td", {
    key: "td-".concat(id),
    className: preparedClassName,
    onClick: handleClickEditableCellButton
  }, useCustomBorder && !isCellEditingCheck && (cellStyleCls && cellStyleCls.indexOf('custom-error') > -1 || cellStyleCls.indexOf('customError') > -1) && /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-border"
  }), (columnDef === null || columnDef === void 0 ? void 0 : columnDef.dataIndex) === 'rowSelection' && /*#__PURE__*/_react.default.createElement(RenderRowSelection, {
    isRowSelectionColumn: (columnDef === null || columnDef === void 0 ? void 0 : columnDef.dataIndex) === 'rowSelection',
    prefixCls: prefixCls,
    rowSelection: rowSelection,
    isActiveFilter: isActiveFilter,
    isFiltered: isFiltered,
    isDisabled: isDisabled,
    rowKey: rowKey,
    rowId: rowId,
    row: row,
    showChildForFilter: showChildForFilter
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cell-container-wrapper",
    style: wrapperStyle
  }, /*#__PURE__*/_react.default.createElement(_RenderInput.RenderExpandIcon, {
    isExpandedColumn: isExpandedColumn,
    expandable: expandable,
    hasChildren: hasChildren,
    cellIndex: cellIndex,
    expandIconColumnIndex: expandIconColumnIndex,
    prefixCls: prefixCls,
    record: row,
    rowId: rowId,
    rowIndex: rowIndex,
    isExpanded: isExpanded,
    setIsExpanded: setIsExpanded,
    isActiveFilter: isActiveFilter
    // expandIcon={expandIcon}
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cell-wrapper",
    style: {
      width: cellIndex === expandIconColumnIndex ? columnDef.size - marginLeft : columnDef.size
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: editableButtonClassname,
    tabIndex: isDisabled ? '-1' : '0',
    type: "ghost",
    onFocus: editOnFocus
  }, /*#__PURE__*/_react.default.createElement(_RenderInput.default, {
    key: "".concat(id, "-renderInput"),
    row: {
      original: row,
      id: row.key,
      index: row.index
    },
    column: {
      dataIndex: columnDef.dataIndex,
      cellChangeTrigger: columnDef.cellChangeTrigger,
      editable: columnDef.editable,
      inputProps: columnDef.inputProps
    },
    undoText: locale === null || locale === void 0 ? void 0 : locale.undo,
    isDisabled: isDisabled,
    selectedCellRef: selectedCellRef,
    rowKey: rowKey,
    isEditing: isEditing,
    setInnerValue: setInnerValue,
    rowId: rowId
  }, childOrValue)))));
};
function RenderRowSelection(props) {
  var isRowSelectionColumn = props.isRowSelectionColumn,
    prefixCls = props.prefixCls,
    rowSelection = props.rowSelection,
    isActiveFilter = props.isActiveFilter,
    isFiltered = props.isFiltered,
    row = props.row,
    rowId = props.rowId,
    rowKey = props.rowKey,
    showChildForFilter = props.showChildForFilter;
  if (isRowSelectionColumn) {
    var className = "".concat(prefixCls, "-row-selection-cell");
    var isSelected = !!(rowSelection.selectedRowKeys || {})[rowId];
    var selectionProps = typeof (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.getCheckboxProps) === 'function' ? rowSelection.getCheckboxProps(_objectSpread(_objectSpread({}, row), {}, {
      isActiveFilter: isActiveFilter && !showChildForFilter
    })) : {};
    return /*#__PURE__*/_react.default.createElement(_RowSelection.default, (0, _extends2.default)({
      rowKey: rowKey,
      rowId: rowId,
      isSelected: isSelected,
      isFiltered: isFiltered
    }, selectionProps));
  }
  return null;
}
function checkDisable(columnDef, row) {
  var isDisabled = false;
  if (columnDef !== null && columnDef !== void 0 && columnDef.disabled) {
    if (typeof (columnDef === null || columnDef === void 0 ? void 0 : columnDef.disabled) === 'function') {
      isDisabled = columnDef === null || columnDef === void 0 ? void 0 : columnDef.disabled(row, row.index);
    } else {
      isDisabled = true;
    }
  }
  return isDisabled;
}
var _default = exports.default = TestEditableCell;